import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import { BrandingProvider } from "./lib/branding";
import { UnreadProvider } from "./lib/unread";
import { initAudioUnlock } from "./lib/sound";
import MobileFrame from "./components/MobileFrame";
import RoleGate from "./components/RoleGate";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import Categories from "./pages/Categories";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Checkout from "./pages/Checkout";
import CustomerOrders from "./pages/CustomerOrders";
import OrderDetail from "./pages/OrderDetail";
import Profile from "./pages/Profile";
import Support from "./pages/Support";
import Enterprise from "./pages/Enterprise";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import PartnerOnboarding from "./pages/PartnerOnboarding";
import PartnerSignup from "./pages/PartnerSignup";

import PartnerDashboard from "./pages/partner/Dashboard";
import PartnerEarnings from "./pages/partner/Earnings";

import AdminDashboard from "./pages/admin/Dashboard";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <BrandingProvider>
          <UnreadProvider>
            <MobileFrame>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/auth-callback" element={<AuthCallback />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/shop/:pid" element={<ProductDetail />} />
                <Route path="/checkout" element={<RoleGate roles={["customer"]}><Checkout /></RoleGate>} />
                <Route path="/orders" element={<RoleGate roles={["customer"]}><CustomerOrders /></RoleGate>} />
                <Route path="/orders/:oid" element={<RoleGate roles={["customer", "partner"]}><OrderDetail /></RoleGate>} />
                <Route path="/profile" element={<RoleGate roles={["customer", "partner", "admin"]}><Profile /></RoleGate>} />
                <Route path="/support" element={<Support />} />
                <Route path="/enterprise" element={<Enterprise />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/partner-onboarding" element={<RoleGate roles={["partner"]}><PartnerOnboarding /></RoleGate>} />
                <Route path="/partner-signup" element={<PartnerSignup />} />
                <Route path="/partner" element={<RoleGate roles={["partner"]}><PartnerDashboard /></RoleGate>} />
                <Route path="/partner/earnings" element={<RoleGate roles={["partner"]}><PartnerEarnings /></RoleGate>} />
                <Route path="/admin" element={<RoleGate roles={["admin"]}><AdminDashboard /></RoleGate>} />
              </Routes>
            </MobileFrame>
            <Toaster position="top-center" richColors />
          </UnreadProvider>
        </BrandingProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
